import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import EditableText from '@/components/EditableText/EditableText.vue';
import CLazy from '@/components/CLazy.vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import BaseLayersTreeItem from '../BaseLayersTreeItem.vue';
import type { ListElements } from '@/typings/customilyElements/layer';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersTreeItemGroup',
  props: {
    item: null,
    collapsed: { type: Boolean }
  },
  emits: ['toggle-collapse'],
  setup(__props: any, { emit }) {

const props = __props as {
    item: ListElements;
    collapsed?: boolean;
};





const { flags, onElementTitleChange, onElementPositionChange } = useLayerTreeItem({
    item: props.item
});

const isSpotifyPlayer = computed(() => {
    return props.item.element.SpotifyPlayer;
});

const onCollapseClick = () => {
    emit('toggle-collapse');
};

return { __sfc: true,emit, props, flags, onElementTitleChange, onElementPositionChange, isSpotifyPlayer, onCollapseClick, EditableText, CLazy, SvgIcon, BaseLayersTreeItem }
}

})